import { Mic } from "lucide-react";

export const Logo = ({ inverted = false, suffix = "", className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <span className={`w-6 h-6 rounded-sm flex items-center justify-center shrink-0 ${inverted ? "bg-white" : "bg-[#111] dark:bg-white"}`}>
      <Mic className={`w-3.5 h-3.5 ${inverted ? "text-[#111]" : "text-white dark:text-[#111]"}`} />
    </span>
    <span className={`font-heading text-lg leading-none tracking-tight ${inverted ? "text-white" : "text-[#111] dark:text-white"}`}>
      <span className="font-bold">EXO</span>
      <span className="font-light tracking-[0.08em]">PILOT</span>
    </span>
    {suffix && (
      <span className="text-[10px] uppercase tracking-[0.22em] mt-0.5 text-neutral-400 border-l border-neutral-300 dark:border-neutral-700 pl-2">{suffix}</span>
    )}
  </span>
);
